import { StyleSheet } from 'aphrodite';
import { THEME } from '../../components-v2/Theme/theme';
import { CssSelectors } from '../../styles/styles';

const { colors, spacing, typography, common } = THEME;

export const ContentWidth = 800;
export const ImageContainerHeight = 350;
export const GifContentWidth = 460;
export const GifsContainerHeight = 350;

export const styleSheet = StyleSheet.create({
	altTextContainer: {
		marginTop: spacing.md,
		padding: `0 ${spacing.lg}px`,
	},
	altTextLabel: {
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.bold,
		marginBottom: spacing.sm,
		color: colors.text.main,
	},
	clearSearch: {
		color: colors.hover.main,
	},
	container: {
		minWidth: 500,
		width: ContentWidth,
		[THEME.queries.md]: {
			width: '100%',
			minWidth: '100%',
		},
	},
	footer: {
		margin: `${spacing.lg}px 0`,
		padding: `0 ${spacing.lg}px`,
	},
	gifs: {
		display: 'flex',
		height: GifsContainerHeight,
		overflowY: 'auto',
		position: 'relative',
	},
	header: {
		borderBottom: common.border,
		color: colors.text.main,
		fontSize: typography.fontSizes.lg,
		justifyContent: 'space-between',
		marginBottom: spacing.lg,
		padding: `0 ${spacing.lg}px`,
	},
	headerPoweredBy: {
		fontSize: typography.fontSizes.xxs,
	},
	headerPoweredByGiphy: {
		alignItems: 'flex-end',
		display: 'flex',
		height: spacing.lg,
		marginRight: spacing.lg,
		marginTop: 6,
		width: 'auto',
	},
	headerPoweredByGiphyImage: {
		height: spacing.lg,
		width: 'auto',
	},
	headerPoweredByGiphyLogo: {
		display: 'flex',
	},
	headerPoweredByImage: {
		height: spacing.md,
		marginRight: spacing.lg,
		width: 'auto',
	},
	headerTabs: {
		alignItems: 'flex-end',
		display: 'flex',
		...CssSelectors.allChildren(
			{
				marginLeft: 50,
			},
			':first-child'
		),
	},
	headerTitle: {
		display: 'flex',
		justifyContent: 'space-between',
	},
	hide: {
		display: 'none',
	},
	imageGrid: {
		alignItems: 'center',
		boxSizing: 'border-box',
		display: 'flex',
		flexWrap: 'wrap',
		height: ImageContainerHeight,
		overflowY: 'auto',
		padding: `0 ${spacing.lg}px`,
		position: 'relative',
		...CssSelectors.allChildren(
			{
				':first-child': {
					marginRight: 6,
				},
				height: 28,
			},
			'button'
		),
	},
	imageGridTile: {
		boxSizing: 'border-box',
		height: '100px !important',
		padding: '0 5px 5px 0',
		...CssSelectors.allChildren(
			{
				height: '100%',
				width: 'auto',
			},
			'img'
		),
	},
	imageGridTileSelected: {
		...CssSelectors.allChildren(
			{
				height: 'auto',
				maxHeight: '50vh',
				maxWidth: '100%',
				width: 'auto',
			},
			'img'
		),
		height: '100%',
		padding: spacing.lg,
	},
	keywordLabel: {
		alignItems: 'center',
		background: colors.pill.yellow.background,
		borderRadius: 11,
		color: colors.text.main,
		display: 'flex',
		fontSize: typography.fontSizes.sm,
		height: 23,
		padding: '2px 12px',
	},
	keywordsSection: {
		height: 23,
	},
	mediaMenu: {
		':hover': {
			background: colors.background.main,
		},
		background: '#ddd5d552',
		border: `1px solid transparent`,
		borderTopLeftRadius: 3,
		borderTopRightRadius: 3,
		color: colors.text.light,
		fontSize: typography.fontSizes.lg,
		fontVariant: 'all-small-caps',
		letterSpacing: 1.2,
		marginLeft: 2,
		padding: `${spacing.sm}px 40px`,
	},
	modal: {
		...CssSelectors.allDescendants(
			{
				padding: 0,
			},
			'.modal-overlay-content'
		),
		...CssSelectors.allDescendants(
			{
				paddingRight: spacing.lg,
				paddingTop: 10,
			},
			'.modal-overlay-content-header'
		),
	},
	noSearchResults: {
		margin: `${spacing.lg}px ${spacing.lg}px 0px ${spacing.lg}px`,
	},
	noSuggestions: {
		alignItems: 'center',
		background: colors.background.main,
		display: 'flex',
		flexDirection: 'column',
		height: 200,
		justifyContent: 'center',
		padding: 10,
	},
	noSuggestionsText: {
		color: colors.text.light,
		fontSize: typography.fontSizes.xs,
		padding: 10,
		textAlign: 'center',
		width: 200,
	},
	noSuggestionsTitle: {
		color: colors.secondary.main,
		fontSize: typography.fontSizes.md,
	},
	search: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		marginBottom: 14,
		marginTop: spacing.lg,
		padding: `0 ${spacing.lg}px`,
		position: 'relative',
	},
	searchIcon: {
		height: 50,
		width: 50,
	},
	searchInput: {
		width: '85%',
	},
	selectedMedia: {
		':hover': {
			background: colors.background.light,
		},
		background: colors.background.light,
		border: common.border,
		borderBottom: '1px solid transparent',
		color: colors.hover.main,
		marginBottom: -1,
	},
	suggestedMedia: {
		alignItems: 'center',
		background: colors.background.main,
		border: common.border,
		borderRadius: common.borderRadius + 5, // 13px (0.8125rem)
		boxShadow: '0px 1px 2px rgba(167,171,173, 0.22)',
		cursor: 'pointer',
		display: 'flex',
		flexDirection: 'column',
		marginTop: spacing.lg,
		overflow: 'hidden',
	},
	suggestedMediaButtonColumn: {
		alignItems: 'center',
		width: 28,
	},
	suggestedMediaHeader: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.standard,
	},
	suggestedMediaImg: {
		height: 135,
		minHeight: 135,
		objectFit: 'cover',
		width: '100%',
	},
	suggestionContainer: {
		borderTop: common.border,
		height: 310,
		padding: `0 ${spacing.lg}px`,
	},
	suggestionHeader: {
		color: colors.hover.main,
		fontSize: typography.fontSizes.md,
		fontWeight: typography.fontWeights.bold,
	},
	suggestionsContainerHidden: {
		display: 'none',
	},
	suggestionSubHeader: {
		color: colors.text.light,
		fontSize: typography.fontSizes.sm,
		fontWeight: typography.fontWeights.standard,
		marginTop: 0,
	},
	// Mobile-specific styles
	[THEME.queries.md]: {
		container: {
			minWidth: 'auto',
			width: '100%',
			maxWidth: '100vw',
		},
		header: {
			fontSize: typography.fontSizes.md,
			padding: `0 ${spacing.md}px`,
			marginBottom: spacing.md,
		},
		headerTitle: {
			flexDirection: 'column',
			alignItems: 'flex-start',
			gap: spacing.sm,
		},
		headerTabs: {
			width: '100%',
			justifyContent: 'flex-start',
		},
		search: {
			padding: `0 ${spacing.md}px`,
			marginTop: spacing.md,
			marginBottom: 12,
		},
		searchInput: {
			width: '100%',
		},
		imageGrid: {
			padding: `0 ${spacing.md}px`,
			height: '60vh',
			maxHeight: 400,
			display: 'grid',
			gridTemplateColumns: 'repeat(auto-fit, minmax(100px, 1fr))',
			gridGap: spacing.sm,
			alignItems: 'start',
			alignContent: 'start',
		},
		imageGridTile: {
			height: 'auto !important',
			padding: 0,
			aspectRatio: '1',
			borderRadius: common.borderRadius,
			overflow: 'hidden',
			border: 'none',
			background: 'none',
			...CssSelectors.allChildren(
				{
					width: '100%',
					height: '100%',
					objectFit: 'cover',
					borderRadius: 6,
				},
				'img'
			),
		},
		imageGridTileSelected: {
			padding: spacing.md,
			...CssSelectors.allChildren(
				{
					borderRadius: common.borderRadius,
					maxWidth: '100%',
					height: 'auto',
					maxHeight: '40vh',
				},
				'img'
			),
		},
		footer: {
			padding: `0 ${spacing.md}px`,
			margin: `${spacing.md}px 0`,
		},
		modal: {
			...CssSelectors.allDescendants(
				{
					padding: 0,
					maxHeight: '90vh',
					width: '100%',
					maxWidth: '100vw',
					margin: 0,
				},
				'.modal-overlay-content'
			),
			...CssSelectors.allDescendants(
				{
					paddingRight: spacing.md,
					paddingLeft: spacing.md,
					paddingTop: spacing.md,
				},
				'.modal-overlay-content-header'
			),
		},
		suggestionContainer: {
			padding: `0 ${spacing.md}px`,
			height: 'auto',
			maxHeight: '50vh',
		},
		altTextContainer: {
			padding: `0 ${spacing.md}px`,
		},
	},
});
